import React, { useState, useEffect, useCallback } from 'react'
import { Grid } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAt } from '@fortawesome/pro-duotone-svg-icons/faAt'

interface UpperMenuContactProps {
    kedo: any
    displayHelpdesk?: boolean
}

export const UpperMenuContact: React.FC<UpperMenuContactProps> = ({
    kedo,
    displayHelpdesk = false,
}) => {
    const [showHelpdesk, setShowHelpdesk] = useState(displayHelpdesk)
    const [helpdeskWidth, setHelpdeskWidth] = useState('16.67%')

    const handleHelpdesk = useCallback(() => {
        setShowHelpdesk((prev) => !prev)
    }, [])

    const setHelpdeskWidthFn = useCallback(() => {
        if (window.innerWidth > 576) {
            setHelpdeskWidth('16.67%')
        } else {
            setHelpdeskWidth('100%')
        }
    }, [])

    useEffect(() => {
        setHelpdeskWidthFn()
        // optional: update width on resize
        window.addEventListener('resize', setHelpdeskWidthFn)
        return () => {
            window.removeEventListener('resize', setHelpdeskWidthFn)
        }
    }, [setHelpdeskWidthFn])

    return (
        <Grid container>
            <Grid size={{ xs: 12, md: 6 }}>
                <div className="mainContainer">
                    <h1>{kedo.t('Do you need help?')}</h1>
                    <br />
                    <Grid
                        container
                        className="uppermenu-contact"
                        sx={{ width: '100%' }}
                    >
                        {/* TODO CHECK IF ENTERPRISE ACCOUNT */}
                        {/* <Grid item xs={12} md={4}>
                <FontAwesomeIcon icon={faPhone} size="3x" /> <br /><br />
                +31 (0) 35 603 00 20
            </Grid> */}

                        <Grid size={{ xs: 12 }}>
                            <FontAwesomeIcon icon={faAt} size="3x" />
                            <br />
                            <br />
                            <a href="mailto:help@xlab.nl">help@xlab.nl</a>
                        </Grid>
                    </Grid>
                    <br />
                    <br />
                    <small>
                        {kedo.t('KeDo Next Gen is a product of')}&nbsp;
                        <strong>
                            <a
                                href="https://www.xlab.nl"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Xlab B.V.
                            </a>
                        </strong>
                    </small>
                </div>
            </Grid>
        </Grid>
    )
}
